var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 73.675,
    viewBox: "0 0 57 73.675",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M47.513,73.675h0L42.77,69l-4.743,4.676L33.283,69,28.54,73.674,23.8,69l-4.743,4.676L14.311,69,9.568,73.674,4.824,69,.081,73.674,0,0,4.744,4.676,9.486,0,14.23,4.676,18.973,0l4.744,4.676L28.459,0,33.2,4.676,37.946,0,42.69,4.676,47.432,0l4.744,4.676L56.92,0,57,73.67,52.257,69l-4.744,4.676ZM13.382,51.563l-.659,1.458a6.429,6.429,0,0,0,3.589,1.2v1.6h1.2V54.207c2.1-.212,3.4-1.351,3.4-2.976,0-1.929-1.608-2.474-3.4-2.9V45.409a6.147,6.147,0,0,1,2.374.78l.6-1.459a6.311,6.311,0,0,0-2.975-.881v-1.6h-1.2v1.632c-2.079.2-3.369,1.337-3.369,2.976,0,1.948,1.594,2.492,3.369,2.918v2.889A5.649,5.649,0,0,1,13.382,51.563ZM25.64,45.746v4.815H42.733V45.746ZM13.43,31.3v7.223h29.3V31.3Zm0-13.242v7.224h29.3V18.057Zm4.083,34.575h0V50.075c1.343.376,1.524.861,1.524,1.286,0,.674-.541,1.125-1.523,1.271Zm-1.2-4.608h0c-.767-.222-1.477-.528-1.477-1.256,0-.7.525-1.169,1.479-1.314v2.569Z",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Quote.d6900b82604a6da60e38edb4b696cb88.svg";